'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('AddBasicAreaController', AddBasicAreaController);

  AddBasicAreaController.$inject = ['Project', 'project', 'errorMessageService',
    'areaTemplateBusinessLogic', 'areaTemplates', '$mdDialog', 'qualityLevels', '$stateParams',
    'ProjectDataservice', 'Labels', 'sgAutocompleteHelpers', '$state'];

  function AddBasicAreaController (ProjectAPI, project, errorMessageService,
    areaTemplateBusinessLogic, areaTemplates, $mdDialog, qualityLevels, $stateParams,
    ProjectDataservice, Labels, sgAutocompleteHelpers, $state) {

    const vm = this;

    vm.LABELS = Labels;

    vm.model = {};
    vm.areaForm = {ref: {}};
    vm.qualityLevels = qualityLevels;
    vm.model.qualityLevel = vm.qualityLevels.find((quality) => quality.value === project.qualityLevel);
    vm.areaTemplates = areaTemplateBusinessLogic.groupAndFlattenAreaTemplates(areaTemplates);

    vm.updateName = (obj) => {
      if (vm.model.template && vm.model.qualityLevel) {
        vm.model.description = vm.model.template.name + ' (' + vm.model.qualityLevel.displayName + ')';
        obj.form.description.$pristine = false;
        obj.form.description.$dirty = true;
      }
      vm.descriptionValid();
    };

    vm.descriptionValid = () => {
      const isValidName = !project.basicAreas.find((basicArea) => basicArea.active === true && basicArea.name === vm.model.description);
      vm.areaForm.ref.description.$setValidity('uniqueName', isValidName);
    };

    vm.submit = function () {
      vm.submitting = true;
      if (vm.areaForm.ref.$valid) {
        const basicArea = {
          _id: project._id,
          versionId: project.versionId,
          basicArea: {
            templateId: vm.model.template._id,
            qualityLevel: vm.model.qualityLevel.value,
            name: vm.model.description,
            functionality: vm.model.template.functionality ? vm.model.template.functionality : 1,
          }
        };

        ProjectAPI.addBasicArea(basicArea).$promise.then(function (data) {
          $mdDialog.hide();
          ProjectDataservice.setProjectById(data.project._id, data.project);
          errorMessageService.showSuccess(vm.LABELS.getLabel('areatemplateadded'));

          // Reload current state to make the new are template show up.
          $state.go($state.current, {}, { reload: true });
        });

      } else {
        vm.submitting = false;
      }
    };

    vm.cancel = () => {
      $mdDialog.cancel();
    };

    vm.fieldsObj = {
      template: {
        fieldType: 'dropdown',
        label: vm.LABELS.getLabel('areatemplate'),
        required: true,
        onChange: vm.updateName,
        options: vm.areaTemplates,
        optionsMapping: {
          displayNameKey: 'name',
        },
        helpKey: 'areatemplate',
        filter: sgAutocompleteHelpers.filter,
        searchTextChanged: false,
        nonAlphabetical: true
      },
      qualityLevel: {
        fieldType: 'dropdown',
        label: vm.LABELS.getLabel('qualitylevel'),
        required: true,
        onChange: vm.updateName,
        options: vm.qualityLevels,
        optionsMapping: {
          displayNameKey: 'displayName'
        },
        helpKey: 'qualityLevel',
        filter: sgAutocompleteHelpers.filter,
        searchTextChanged: false,
        nonAlphabetical: true
      },
      description: {
        fieldType: 'input',
        label: vm.LABELS.getLabel('areatemplatename'),
        required: true,
        onChange: vm.descriptionValid,
        helpKey: 'description',
        validationErrors: {
          uniqueName: vm.LABELS.getLabel('uniquename')
        }
      }
    };

    vm.buttonsCb = (i) => {
      vm.buttons[i].cb();
    };

    vm.buttons = [{
      label: vm.LABELS.getLabel('cancel'),
      type: 'button',
      cb: vm.cancel,
    }, {
      label: vm.LABELS.getLabel('save'),
      type: 'submit',
      validateForm: true,
      cb: vm.submit,
    }];
  }
})();
